import { Factory } from '../../engine/http/factory/factory';
import { ChangelogVersion } from './changelog-version';
import { BoChangelogVersionInterface } from '../../interface/changelog/bo-changelog-version.interface';
import { ChangelogEntry } from './changelog-entry';
import dayjs from 'dayjs';
import { ChangelogTypeEnum } from '../../enum/changelog-type.enum';

export class ChangelogVersionFactory implements Factory<ChangelogVersion> {
  public api: string;

  constructor(api: string) {
    this.api = api;
  }

  build(o: BoChangelogVersionInterface): ChangelogVersion {
    const version: ChangelogVersion = new ChangelogVersion(
      o.id,
      dayjs(o.date, 'DD/MM/YYYY').toDate(),
      o.title
    );
    for (const e of o.entries) {
      version.entries.push(
        new ChangelogEntry(e.id, e.title, e.message, ChangelogTypeEnum[e.type])
      );
    }
    return version;
  }

  getApi(): string {
    return this.api;
  }
}
